import { render } from "./VerificationLabel.vue?vue&type=template&id=b19e18fc"
import script from "./VerificationLabel.vue?vue&type=script&lang=js"
export * from "./VerificationLabel.vue?vue&type=script&lang=js"
script.render = render

export default script